import { useScript } from 'hooks/useScript';
import React from 'react';

// Docs: https://platform.zapier.com/partners/zap-templates#support-for-react

type Props = {
  templateIds: string[];
  containerId?: string;
};

export const ZapTemplate: React.FC<Props> = ({
  templateIds,
  containerId = 'id',
}: Props) => {
  const templateIdsTrimed = templateIds.reduce<string[]>(
    (reducedIds, currentId) => {
      if (currentId) {
        reducedIds.push(currentId.trim());
      }
      return reducedIds;
    },
    [],
  );
  const idsString = templateIdsTrimed.join(',');
  const refId = `zapier-template-container_${containerId}_${templateIdsTrimed.join(
    '-',
  )}`;
  const containerRef = React.useRef<null | HTMLDivElement>(null);

  useScript(
    `https://zapier.com/zapbook/embed/widget.js?guided_zaps=${idsString}&html_id=${refId}`,
    containerRef,
  );

  return <div ref={containerRef} id={refId} />;
};
